import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.css";

const ButtonGroup = ({ buttons, selected, onClick, wrapperClass }) => {
  return (
    <div className={`${style.wrapper} ${wrapperClass}`}>
      {buttons.map(button => (
        <button
          disabled={button.disabled}
          key={`text-panel-button-${button.id}`}
          onClick={() => onClick(button.id)}
          className={`${style.button} ${
            selected === button.id ? style.selected : null
          }`}
        >
          {button.label}
        </button>
      ))}
    </div>
  );
};
ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(Object).isRequired,
  selected: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  wrapperClass: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default ButtonGroup;
